<template>
  <v-row>
    <v-col cols="12">
      <!-- bank accounts -->
      <v-expansion-panels v-if="revenueBeta" class="mb-5" :value="banksPanel" @change="setBanksPanel" multiple inset>
        <v-expansion-panel>
          <v-expansion-panel-header class="px-4 py-3">
            <v-row no-gutters align="center" justify="space-between">
              <v-col>
                <span class="d-block text--secondary subtitle-1 font-weight-medium">Cuentas bancarias</span>
              </v-col>
              <v-col class="text-right mr-4" v-if="!banksPanel.length">
                <span class="d-block body-2">
                  <v-chip color="primary" text-color="white" small>{{banksList.length}} {{banksList.length === 1 ? 'cuenta conectada' : 'cuentas conectadas'}}</v-chip>
                  <v-tooltip color="primary" dark max-width="280" top transition="scale-transition" v-if="banksWithIssues">
                    <template v-slot:activator="{on}">
                      <v-icon v-on="on" class="ml-1 mt-n1" color="amber accent-4" small>mdi-alert-circle</v-icon>
                    </template>
                    <span class="white--text">{{banksWithIssues}} {{banksWithIssues === 1 ? 'cuenta tiene' : 'cuentas tienen'}} un problema de conexión</span>
                  </v-tooltip>
                </span>
              </v-col>
            </v-row>
          </v-expansion-panel-header>

          <v-expansion-panel-content class="px-0" eager>
            <bank-account-carousel @change="getList(false)" />
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
      <!-- end bank accounts -->

      <!-- fast state -->
      <v-card>
        <v-tabs background-color="background" color="primary" grow height="55" slider-size="4">
          <v-tab class="text-none font-weight-medium" to="/transactions" exact>Todos los movimientos</v-tab>
          <v-divider vertical />
          <v-tab class="text-none font-weight-medium" to="/transactions?status=pending" exact>Pendiente</v-tab>
          <v-divider vertical />
          <v-tab class="text-none font-weight-medium" to="/transactions?status=incomplete" exact>Incompleto</v-tab>
          <v-divider vertical />
          <v-tab class="text-none font-weight-medium" to="/transactions?status=finalized" exact>Conciliado</v-tab>
          <v-divider vertical />
          <v-tab class="text-none font-weight-medium" to="/transactions?status=archived" exact>Archivado</v-tab>
        </v-tabs>
      </v-card>
      <!-- end fast state -->

      <v-card class="px-0 mt-5">
        <v-skeleton-loader v-if="$store.state.banks.retrieveLoader" transition="fade-transition" type="toolbar" />
        <v-toolbar v-else color="transparent" flat height="55">
          <v-toolbar-title class="text--secondary subtitle-1 font-weight-medium">{{ revenueBeta ? 'Conciliación' : 'Transferencias' }}</v-toolbar-title>
          <v-spacer />
          <v-toolbar-items>
            <v-row align="center" justify="center" class="mr-1">
              <v-query-builder :query-map="filters" model="transactions" />
            </v-row>
          </v-toolbar-items>
        </v-toolbar>
        <v-divider />
        <v-card-text class="px-0 py-0">
          <transaction-list :show-create="true" />
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>
<script>
import { transfersFilters } from '../../collections/queryBuilderFilters'
import BankAccountCarousel from '@/components/bank/BankAccountCarousel'
import TransactionList from '@/components/bank/TransactionList'
import VQueryBuilder from '@/components/VQueryBuilder/VQueryBuilder'
import ListViewMixin from '@/mixins/ListViewMixin'
import RevenueBetaMixin from '@/mixins/RevenueBetaMixin'

export default {
  components: {
    BankAccountCarousel,
    TransactionList,
    VQueryBuilder
  },
  mixins: [
    ListViewMixin,
    RevenueBetaMixin
  ],
  data: () => ({
    filters: transfersFilters
  }),
  computed: {
    banksPanel () {
      return this.$store.state.ui.panels.banks
    },
    banksList () {
      return this.$store.state.accounts.banksList
    },
    banksWithIssues () {
      return this.banksList.filter(b => b.status !== 'active').length
    }
  },
  methods: {
    setBanksPanel (value) {
      this.$store.commit('ui/SET_PANEL', { panel: 'banks', value: value })
    },
    getList (loader = true) {
      this.$store.dispatch('banks/LIST', {
        resource: 'ach_transfers',
        query: this.$route.query,
        loader: loader
      })
    }
  }
}
</script>